module.exports = "<br/><h2>\n  <strong>Current fires blazing around the world!</strong>\n</h2><br/>\n<div id='map-container'></div>"